export const loginStore = {
    namespaced: true,
    state : {
        FiltroHome: {},
    },
    mutations : {
    },
    actions : {
    },
    getters : {
        FiltroHome: (state, getters) => {
            return state.FiltroHome;
        },   
    }
}